import React from 'react';

import './aboutPage.scss';
export default function aboutPage() {
  return (
      <>
    <h2 className="sub">About Page</h2>
    <div class="about-grid-container">
    
        <div class="diane about-card">
            
            <h4>Diane Stephani <p className="team">Project Manager</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/dianestephani" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>*/}
            <a href="https://www.linkedin.com/in/dianestephani/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a> 
        </div>
    </div>
  



    <div class="peng about-card">
            <h4>Peng Chen <p className="team">Backend</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/PengChen11" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>*/}
            <a href="https://www.linkedin.com/in/pengchen11/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a> 
        </div>
    </div>

    <div class="joe about-card">
            <h4>Joe Pennock <p className="team">Game Logic</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/penjoe" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
            <a href="https://www.linkedin.com/in/joepennock/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
        </div>
    </div>



    <div class="kory about-card">
            <h4>Kory Jackson<p className="team">Game Logic</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/Dirrbick" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
            <a href="https://www.linkedin.com/in/kory-jackson-927363164/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
        </div>
    </div>

   
    <div class="brendon about-card">
            <h4>Brendon Hampton<p className="team">UI / UX</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/BrendonLH" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
            <a href="https://www.linkedin.com/in/brendon-hampton-37132899/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
        </div>
    </div>



    <div class="chris about-card">
            <h4>Chris Bortel <p className="team">UI / UX</p></h4>
        
        <article>
            <p> 
            {/* Simplified personal pitch (where you're from, what your goals are, etc.) */}
            The path of the righteous man is beset on all sides by the iniquities of the selfish and the tyranny of evil men. Blessed is he who, in the name of charity and good will, shepherds the weak through the valley of darkness, for he is truly his brother's keeper and the finder of lost children. And I will strike down upon thee with great vengeance and furious anger those who would attempt to poison and destroy My brothers. And you will know My name is the Lord when I lay My vengeance upon thee.
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/Chris-Bortel" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>

            <a href="https://twitter.com/bortel_chris" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"> </a>

            <a href="https://www.linkedin.com/in/chris-bortel/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
        </div>
    </div>





    <div class="edgar about-card">
            <h4>Edgar Romero<p className="team">UI / UX</p></h4>
        
        <article>
            <p> 
            Simplified personal pitch (where you're from, what your goals are, etc.)
            <br/>
            <br/>
            Fun fact:
            </p>
        </article>
            {/* image */}
        <div className="social-icons">
            <a href="https://github.com/Edgar-Romero87" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
            {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>*/}
            <a href="https://www.linkedin.com/in/edgarromero1987/" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"> </a> 
        </div>
    </div>

    </div>
    {/* <div class="footer"><Footer/></div> */}
    
    
    </>
)
}





// {/* Backend */}
// <div className="card">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Peng Chen<br /><span>Backend</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/PengChen11" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div>

// {/* Game Logic */}
//     <div className="card">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Joe Pennock<br /><span>Game Logic</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/penjoe" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div>

//     <div className="card">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Kory Jackson<br /><span>Game Logic</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/Dirrbick" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div>


// {/* UI/UX */}
//     <div className="card">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Brendon Hampton<br /><span>UI/UX</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/BrendonLH" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div>

//     <div className="card">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Edgar Romero<br /><span>UI/UX</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/Edgar-Romero87" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div>

//     <div className="aboutCard">
//         <div className="card-front"></div>
//         <div className="card-back">
//             <h4>Chris Bortel<br /><span>UI/UX</span></h4>
//             <div className="social-icons">
//                 <a href="https://github.com/Chris-Bortel" className="fab fa-github" aria-hidden="true" target="_blank" rel="noreferrer"> </a>
//                 {/* <a href="#" className="fa fa-twitter" aria-hidden="true" target="_blank" rel="noreferrer"></a>
//                 <a href="#" className="fa fa-linkedin" aria-hidden="true" target="_blank" rel="noreferrer"></a> */}
//             </div>
//         </div>
//     </div> */}






// <section className="wrapper">
// <div className="aboutCard" >
//     1. Diane Stephani<br /><span>Game Logic</span>
// </div>


// <div className="aboutCard" item1>
//     2. Peng Chen<br /><span>Backend</span>
// </div>

// <div className="aboutCard">
// 3. Joe Pennock <br /><span>Game Logic</span>
// </div>

// <div className="aboutCard">
// 4. Kory Jackson<br /><span>Game Logic</span>
// </div>


// <div className="aboutCard">
// 5. Brendon Hampton<br /><span>UI/UX</span>
// </div>

// <div className="aboutCard">
// 6. Edgar Romero<br /><span>UI/UX</span>
// </div>

// <div className="aboutCard">
// 7. Chris Bortel<br /><span>UI/UX</span>
// </div>
// </section>
